import { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  Grid,
  FormControl,
  CircularProgress,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { pdf } from "@react-pdf/renderer";

import {
  GetAdminTaxDeclarationHelper,
  GetTaxReportHelper,
  GetTaxReportRegimeCalculationHelper,
} from "../../helper/TaxDeclarationHelper";
import { ConvertDate, currentMonth, getUserData, month } from "../../../Base/helper/baseFunctions";
import TaxReport from "../TaxDeclaration/TaxReport";
import { useSelector } from "react-redux";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

const MyEmployeeTaxReport = () => {
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingviewRowId, setViewLoadingRowId] = useState(null);
  const [loadingviewRowId2, setViewLoadingRowId2] = useState(null);
  const [financialYear, setFinancialYear] = useState(null);
  const [taxReportMonth, setTaxReportMonth] = useState({});
  const userData = getUserData();
  const { minDojYear } = useSelector(state => state?.AncillaryReducer?.WorkSpaceDojReducer);
  const currentYear = new Date().getFullYear();
  const dojDate = new Date(minDojYear);
  const dojYear = dojDate.getFullYear();
  const dojMonth = dojDate.getMonth() + 1; 
  const startYear = dojMonth <= 3 ? dojYear - 1 : dojYear;
  const years = Array.from({ length: currentYear - startYear + 1 },(_, i) => startYear + i);
  const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
  const [filters, setFilters] = useState({
          ats_work_location_id: []
    });
  const [worklocationData, setWorklocationData] = useState({
              load: true,
              values: [],
        });
  const handleWorkLoacation = () => {
      if(workLocationAccess_options) {
          setWorklocationData({ load: false, values: workLocationAccess_options || [] })
      } else {
          setWorklocationData({ load: false, values: [] })
      }
  }
  useEffect(() => {
      handleWorkLoacation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[workLocationAccess_options])
  const handleFilterChange = (event, value) => {
      if (["ats_work_location_id"].includes(event)) {
      if (value) {
          setFilters({ ...filters, [event]: value });
      } else {
          setFilters({ ...filters, [event]: "" });
      }
      }
  }
  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    setTaxReportMonth({month: month[currentMonth], year: currentYear});
    const toYear = currentYear + 1;
    const fromYear = currentYear;
    setFinancialYear(`${fromYear}-${toYear}`);
  }, []);
  useEffect(() => {
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    setLoading(true);
    GetAdminTaxDeclarationHelper({ emp_id: null,
        ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
     })
      .then((res) => {
        if (res?.data?.statuscode === 200) {
          setEmployeeData(res?.data?.data);
        }
      })
      .finally(() => setLoading(false));
  }, [filters]);
  const handleDownloadPDF = async (rowData, action) => {
    if (action === "pdf") {
      setViewLoadingRowId(rowData?.employee_id);
    } else {
      setViewLoadingRowId2(rowData?.employee_id);
    }

    try {
      const response = await GetTaxReportHelper({
        emp_id: rowData?.employee_id,
        fromYear: financialYear.split("-")[0],
        toYear: financialYear.split("-")[1],
        month: currentMonth(),
      });
      if (response?.data?.statuscode === 200 && response?.data?.data?.[0]) {
        const data = response?.data?.data?.[0];
         const financialYearMonths = [
          "April", "May", "June", "July", "August", "September",
          "October", "November", "December", "January", "February", "March"
        ];
      const actualMonthsFromData = Object.keys(data?.actuals || {});
      const projectedMonthsFromData = Object.keys(data?.projected || {});

      const sortMonths = (months) =>
        months?.sort(
          (a, b) =>
            financialYearMonths.indexOf(a) - financialYearMonths.indexOf(b)
        );
      const sortedProjected = sortMonths([...projectedMonthsFromData]);

      // Find the first projected month (e.g. "July")
      const firstProjectedMonth = sortedProjected[0];
      const firstProjectedIndex = financialYearMonths.indexOf(firstProjectedMonth);

      const paddedActualMonths = financialYearMonths
        .slice(0, firstProjectedIndex)
        .concat(actualMonthsFromData);

      // Remove duplicates and sort
      const actualMonths = sortMonths([...new Set(paddedActualMonths)]);
      const projectedMonths = sortMonths(projectedMonthsFromData);

        const allMonths = [...actualMonths, ...projectedMonths];
        const checkRegimeOpted = () => {
          const employeeInfo = data?.employee_info?.[0];
          if (!employeeInfo) return null;
          const regime =
            employeeInfo.regime_opted === "old_regime" ? "OLD" : "NEW";
          return regime;
        };
        const result = {
          earnings: {},
          deductions: {},
        };

        allMonths?.forEach((month) => {
          ["actuals", "projected"].forEach((category) => {
            const monthData = data[category]?.[month];

            if (monthData) {
              const earnings = Array.isArray(monthData.earnings)
                ? monthData.earnings[0]
                : monthData.earnings;
              const deductions = Array.isArray(monthData.deductions)
                ? monthData.deductions[0]
                : monthData.deductions;

              // Process earnings
              if (earnings) {
                Object.entries(earnings).forEach(([component, value]) => {
                  if (!result?.earnings[component]) {
                    result.earnings[component] = {};
                  }
                  result.earnings[component][month] = Number(value) || 0;
                });
              }

              // Process deductions
              if (deductions) {
                Object.entries(deductions).forEach(([component, value]) => {
                  if (!result?.deductions[component]) {
                    result.deductions[component] = {};
                  }
                  result.deductions[component][month] = Number(value) || 0;
                });
              }
            }
          });
        });

        // Process employee_post_adjustment_component_earning_json
        if (Array.isArray(data?.employee_post_adjustment_component_earning_json)) {
          const flatObject = {};
          data?.employee_post_adjustment_component_earning_json?.forEach((component) => {
            const { label, amount, taxable_flag, post_adjustment_components_id } = component;
            if (taxable_flag) {
              const uniqueKey = `${post_adjustment_components_id}_${label}`;
              const value = parseFloat(amount || 0);

              if (flatObject[uniqueKey]) {
                flatObject[uniqueKey] += value;
              } else {
                flatObject[uniqueKey] = value;
              }
            }
          });

          Object.entries(flatObject)?.forEach(([key, totalAmount]) => {
            const label = key.split("_").slice(1).join("_");
            if (!result?.earnings[label]) {
              result.earnings[label] = {};
            }

            allMonths?.forEach((month) => {
              if (actualMonths?.includes(month)) {
                result.earnings[label][month] = (result.earnings[label][month] || 0) + totalAmount;
              } else if (projectedMonths?.includes(month)) {
                result.earnings[label][month] = 0; 
              }
            });
          });
        }
       // Process employee_post_adjustment_component_deduction_json
        if (Array.isArray(data?.employee_post_adjustment_component_deduction_json)) {
          const flatObject = {};
          data?.employee_post_adjustment_component_deduction_json?.forEach((component) => {
            const { label, amount, post_adjustment_components_id } = component;
            const uniqueKey = `${post_adjustment_components_id}_${label}`;
            const value = parseFloat(amount || 0);

            if (flatObject[uniqueKey]) {
              flatObject[uniqueKey] += value;
            } else {
              flatObject[uniqueKey] = value;
            }
          });

          Object.entries(flatObject)?.forEach(([key, totalAmount]) => {
            const label = key.split("_").slice(1).join("_"); 
            if (!result?.deductions[label]) {
              result.deductions[label] = {};
            }

            allMonths?.forEach((month) => {
              if (actualMonths?.includes(month)) {
                result.deductions[label][month] = (result.deductions[label][month] || 0) + totalAmount;
              } else if (projectedMonths?.includes(month)) {
                result.deductions[label][month] = 0; 
              }
            });
          });
        }
        // Filter out components with all fields 0 or null for earnings
        Object.keys(result.earnings).forEach((component) => {
          const isAllZeroOrNull = allMonths.every(
            (month) => !result.earnings[component][month] || result.earnings[component][month] === 0
          );
          if (isAllZeroOrNull) {
            delete result.earnings[component];
          }
        });

        // Filter out components with all fields 0 or null for deductions
        Object.keys(result.deductions).forEach((component) => {
          const isAllZeroOrNull = allMonths.every(
            (month) => !result.deductions[component][month] || result.deductions[component][month] === 0
          );
          if (isAllZeroOrNull) {
            delete result.deductions[component];
          }
        });
        // Overall Total Calculator
        const calculateOverallTotal = (data) => {
          return Object.keys(data).reduce((grandTotal, component) => {
            return (
              grandTotal +
              allMonths.reduce((total, month) => {
                return total + Number(data?.[component]?.[month] || 0);
              }, 0)
            );
          }, 0);
        };
        const totalEarnings = calculateOverallTotal(result?.earnings);
        const netSalary =
          Number(totalEarnings) -
          (Number(data?.tax_summary?.profession_tax) +
            Number(data?.tax_summary?.standard_deduction));

        // section show based on regimeSelected
        const declarations = data?.proofs_received || {};

        const sectionSummary = Object.entries(declarations)
          .filter(
            ([section]) => checkRegimeOpted() === "OLD" || section === "Section 24"
          )
          .map(([section, entries]) => {
            let total = 0;
            if (["House Rent Exemption", "Section 24"].includes(section)) {
              const safeEntries = Array.isArray(entries) ? entries : [];
              total = safeEntries.reduce((acc, obj) => {
                const sum = Object.values(obj).reduce(
                  (s, val) => s + Number(val || 0),
                  0
                );
                return acc + sum;
              }, 0);
            } else {
              const components = entries?.[0] || {};
              total = Object.values(components).reduce(
                (sum, val) => sum + Number(val || 0),
                0
              );
            }
            return {
              section,
              total,
            };
          });
        const allSumSection = sectionSummary.reduce(
          (sum, item) => sum + Number(item.total || 0),
          0
        );
        const taxableIncome = Number(netSalary) - Number(allSumSection);
        const roundedIncome = Math.round((+taxableIncome + Number.EPSILON) * 100) / 100;
        const res = await GetTaxReportRegimeCalculationHelper({
          taxable_income: roundedIncome,
          regime_type: data?.employee_info?.[0]?.regime_opted,
        });

        if (res?.data?.statuscode === 200) {
          const MyDocument = (
            <TaxReport
              data={data}
              slabSplitData={res?.data?.data?.[0]}
              actualMonths={actualMonths}
              projectedMonths={projectedMonths}
              allMonths={allMonths}
              checkRegimeOpted={checkRegimeOpted}
              result={result}
              calculateOverallTotal={calculateOverallTotal}
              totalEarnings={totalEarnings}
              allSumSection={allSumSection}
              sectionSummary={sectionSummary}
              taxableIncome={taxableIncome}
              companyName={userData?.company_full_name}
              taxReportMonth={taxReportMonth}
              fromYear= {financialYear.split("-")[0]}
              toYear= {financialYear.split("-")[1]}
            />
          );
          //TaxReport_EmployeeNO_FY_2025-2026
          const blob = await pdf(MyDocument).toBlob();
          const fileNameReport = `TaxReport_${data?.employee_info?.[0]?.employee_no}_FY_${financialYear}.pdf` 
          if (action === "pdf") {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileNameReport;
            a.click();
            URL.revokeObjectURL(url);
          } else {
            const fileName = fileNameReport;
            const file = new File([blob], fileName, {
              type: "application/pdf",
            });
            const url = URL.createObjectURL(file);
            const newWindow = window.open(url, "_blank");
            if (
              !newWindow ||
              newWindow.closed ||
              typeof newWindow.closed === "undefined"
            ) {
              alert("Please allow popups for this site to view the tax report");
            }
          }
        }
      }
    } catch (error) {
      console.error("Error generating the PDF:", error);
    } finally {
      setViewLoadingRowId(null);
      setViewLoadingRowId2(null);
    }
  };
  const handleFinancialYearChange = (date) => {
    if (date) {
      setFinancialYear(date);
    } else {
      setFinancialYear(null);
    }
  };
  return (
    <Box sx={{ maxHeight: "calc(100vh - 115px)", overflowY: "auto" }}>
      <Box sx={{ m: 1 }}>
        <Grid
          sx={{ display: "flex", justifyContent: "space-between" }}
          container
          columnSpacing={1}
          mb={1}
        >
          <FormControl sx={{
              minWidth: 160, 
              maxWidth: 200,
              
            }}>
            <InputLabel >Select Financial Year</InputLabel>
            <Select
              value={financialYear || ""}
              label="Select Financial Year"
              onChange={(e) => handleFinancialYearChange(e.target.value)}
              sx={{
                size: "small",
                height: "35px",
                display: "flex",
                alignItems: "center",
                ml:"4px"
              }}
            >
              {years.map((year) => (
                <MenuItem key={year} value={`${year}-${year + 1}`}>
                  {`${year}-${year + 1}`}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
        </Grid>
      </Box>

      <Box>
        <MaterialTable
          isLoading={loading}
          columns={[
            {
              title: "Employee No",
              field: "employee_no",
              cellStyle: { padding: "0px 10px 0px 13px" },
              grouping: false,
            },
            {
              title: "Name",
              field: "employee_name",
              cellStyle: { padding: "0px 10px 0px 13px" },
              grouping: false,
            },
            {
              title: "Designation",
              field: "designation",
              cellStyle: { padding: "0px 10px 0px 13px" },
              grouping: false,
            },
            {
                title: "Work Location",
                field: "work_location_name",
                cellStyle: { padding: "0px 10px 0px 13px" },
                grouping: false,
                render: (rowData) => rowData?.work_location_name || "N/A"
            },
            {
              title: "Joining Date",
              field: "doj",
              cellStyle: { padding: "0px 10px 0px 13px" },
              render: (rowData) => {
                return ConvertDate(rowData.doj);
              },
              grouping: false,
            },
            {
              title: "View Tax Report",
              headerStyle: { textAlign: "left" },
              cellStyle: { padding: "0px 10px 0px 35px", textAlign: "left" },
              sorting: false,
              render: (rowData) => {
                return loadingviewRowId2 === rowData.employee_id ? (
                  <CircularProgress size={20} />
                ) : (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownloadPDF(rowData, "preview");
                    }}
                  >
                    <VisibilityIcon
                      sx={{
                        color: "action",
                      }}
                    />
                  </IconButton>
                );
              },
            },
            {
              title: "Download Tax Report",
              headerStyle: { textAlign: "left" },
              cellStyle: { padding: "0px 10px 0px 45px", textAlign: "left" },
              sorting: false,
              render: (rowData) => {
                return loadingviewRowId === rowData.employee_id ? (
                  <CircularProgress size={20} />
                ) : (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownloadPDF(rowData, "pdf");
                    }}
                  >
                    <CloudDownloadOutlinedIcon
                      sx={{
                        color: "action",
                      }}
                    />
                  </IconButton>
                );
              },
            },
          ]}
          data={employeeData}
          options={{
            maxBodyHeight: "calc(100vh - 300px)",
            minBodyHeight: "calc(100vh - 300px)",
            maxWidth: "80vh",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
              padding:"5px 0px"
            },
            headerStyle: {
              padding: "5px 10px 5px 13px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            columnsButton: false,
            showTitle: true,
          }}
          title=""
          components={{
              Toolbar: (props) => (
                  <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                      <Box
                          sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#f3edfd",
                          padding: "0px 0px 0px 20px",
                          flexGrow: 1,
                          minHeight: "48px !important",
                          }}
                      >
                      <Box>
                          <Typography variant='h6'>
                              Tax Report
                          </Typography>
                      </Box>
                      <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                          <SelectableMultiSelect
                              multiple
                              label="Work Location"
                              placeholder="Select Location"
                              value={filters?.ats_work_location_id}
                              loading={handleWorkLoacation}
                              fieldLabel="work_location_name"
                              name="ats_work_location_id"
                              size="small"
                              onChangeEvent={handleFilterChange}
                              data={worklocationData}
                              menuHeight={150} // optional
                          />
                      </Box> 
                      </Box>
                      <Box
                          sx={{
                              "& .MuiToolbar-root": {
                              padding: "12px 16px !important",
                              margin: "auto !important",
                              minHeight: "48px !important",
                              },
                              "& .MuiFormControl-root": {
                              margin: "0 !important",
                              },
                              "& .MuiInputBase-root": {
                              marginLeft: "-20px !important",
                              }
                          }}
                          >
                              <MTableToolbar {...props} />
                          </Box>
                      </Box>
              ),
          }}
        />
      </Box>
    </Box>
  );
};

export default MyEmployeeTaxReport;
